import React, { useEffect, useState, lazy } from 'react';
import { LeadForm } from './LeadForm';
import { PhoneIcon, StarIcon, ShieldCheckIcon, ClockIcon, DollarSignIcon, X, BuildingIcon } from 'lucide-react';
export function CommercialLanding() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  // Prevent scrolling when modal is open
  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isModalOpen]);
  return <div className="min-h-screen bg-white font-sans text-[#1B2A3D] pb-20 md:pb-0" data-id="element-1">
      {/* Urgency Bar */}
      <div className="bg-[#1B2A3D] text-white text-sm md:text-base font-bold py-2 px-4 text-center" data-id="element-2">
        ⚡ LIMITED AVAILABILITY — Priority Scheduling for Commercial Contracts
      </div>

      {/* Header */}
      <header className="bg-[#0C8CE9] sticky top-0 z-40" data-id="element-3">
        <div className="max-w-6xl mx-auto px-3 py-1.5 flex justify-between items-center" data-id="element-4">
          <img src="https://cdn.magicpatterns.com/uploads/12oFyLJ3njFiy4SGXXx26A/BlueCactus_Power_Washing_Logo_White.svg" alt="Blue Cactus Power Washing" className="h-7 md:h-9 w-auto" data-id="element-5" />
          <button onClick={() => setIsModalOpen(true)} className="flex items-center gap-1.5 bg-white/15 hover:bg-white/25 text-white font-bold text-xs md:text-sm py-1 px-3 rounded-full transition-colors" data-id="element-6">
            <PhoneIcon className="w-3.5 h-3.5" data-id="element-7" />
            <span data-id="element-8">(480) 599-8442</span>
          </button>
        </div>
      </header>

      <main data-id="element-9">
        {/* Hero Section */}
        <section className="relative py-16 md:py-24 px-4 overflow-hidden bg-gradient-to-b from-[#D4EDFB] to-[#B8DFF7] md:bg-none" data-id="element-10">
          <div className="absolute inset-0 bg-cover bg-center hidden md:block" style={{
          backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/fyF4Rsac6iP4SmaWdbiZbY/commercial_1.webp)'
        }} data-id="element-11" />
          <div className="absolute inset-0 bg-white/85 hidden md:block" data-id="element-12" />
          <div className="relative max-w-4xl mx-auto text-center" data-id="element-13">
            <p className="text-[#0C8CE9] font-bold tracking-wider uppercase text-sm md:text-base mb-4 flex items-center justify-center gap-2" data-id="element-14">
              <BuildingIcon className="w-5 h-5" data-id="element-15" />
              Commercial Power Washing — Phoenix Valley
            </p>
            <h1 className="text-4xl md:text-6xl font-extrabold text-[#1B2A3D] leading-tight mb-6" data-id="element-16">
              Parking Lots. Storefronts. Buildings.{' '}
              <br className="hidden md:block" data-id="element-17" />
              <span className="text-[#0C8CE9]" data-id="element-18">
                We Keep Your Business Spotless.
              </span>
            </h1>
            <p className="text-lg md:text-xl text-[#1B2A3D] mb-8 max-w-2xl mx-auto opacity-90" data-id="element-19">
              Professional commercial power washing for Phoenix Valley
              businesses. After-hours service available. Recurring maintenance
              contracts. 100+ commercial properties maintained.
            </p>

            <button onClick={() => setIsModalOpen(true)} className="bg-[#0C8CE9] hover:bg-[#0a7bc0] text-white font-bold text-xl py-4 px-10 rounded-full shadow-lg transform transition hover:scale-105 mb-8" data-id="element-20">
              Get a Commercial Quote &rarr;
            </button>

            <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-sm md:text-base font-semibold text-[#1B2A3D]" data-id="element-21">
              <div className="flex items-center gap-1" data-id="element-22">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-[#F5A623] fill-current" data-id="element-23" />)}
                <span className="ml-2" data-id="element-24">150+ Five-Star Google Reviews</span>
              </div>
              <div className="hidden md:block w-1.5 h-1.5 rounded-full bg-[#1B2A3D] opacity-30" data-id="element-25"></div>
              <div className="flex items-center gap-2" data-id="element-26">
                <ShieldCheckIcon className="w-5 h-5 text-[#0C8CE9]" data-id="element-27" />
                <span data-id="element-28">Licensed • Bonded • Insured</span>
              </div>
            </div>
          </div>
        </section>

        {/* Trusted By Section */}
        <section className="py-12 bg-gray-50 border-y border-gray-200 overflow-hidden" data-id="element-29">
          <div className="max-w-6xl mx-auto text-center px-4 mb-8" data-id="element-30">
            <h2 className="text-2xl font-bold text-[#1B2A3D] mb-2" data-id="element-31">
              Trusted by Leading Phoenix Valley Businesses
            </h2>
            <p className="text-[#1B2A3D] opacity-70" data-id="element-32">
              Join 100+ commercial properties we maintain across the Valley
            </p>
          </div>
          <div className="relative w-full overflow-hidden" data-id="element-33">
            {/* Fade edges */}
            <div className="absolute left-0 top-0 bottom-0 w-16 md:w-24 bg-gradient-to-r from-gray-50 to-transparent z-10" data-id="element-34" />
            <div className="absolute right-0 top-0 bottom-0 w-16 md:w-24 bg-gradient-to-l from-gray-50 to-transparent z-10" data-id="element-35" />
            <div className="flex items-center gap-12 md:gap-16 w-max" style={{
            animation: 'logo-scroll 30s linear infinite'
          }} data-id="element-36">
              {/* First set */}
              <img src="https://cdn.magicpatterns.com/uploads/1ehYujopSpTK2NrZTqZpRk/birdcall-logo-color.svg" alt="Birdcall" className="h-10 md:h-14 w-auto object-contain flex-shrink-0" data-id="element-37" />
              <img src="https://cdn.magicpatterns.com/uploads/8YgbepPhZATz9aUogugo3L/bosa-donuts-logo-color.svg" alt="BoSa Donuts" className="h-10 md:h-14 w-auto object-contain flex-shrink-0" data-id="element-38" />
              <img src="https://cdn.magicpatterns.com/uploads/ffAJewCc2GvRFFDpoFKEVn/chopshop-logo-1024x512.webp" alt="Original ChopShop" className="h-10 md:h-14 w-auto object-contain flex-shrink-0" data-id="element-39" />
              <img src="https://cdn.magicpatterns.com/uploads/gNTQzPAt6hsyThojg6nfTt/darwin-wall-real-estate-team-logo-1024x512.webp" alt="Darwin Wall Real Estate Team" className="h-10 md:h-14 w-auto object-contain flex-shrink-0" data-id="element-40" />
              <img src="https://cdn.magicpatterns.com/uploads/pVcdgmgAGupmatevAoqQnh/dukes-roadhouse-logo-color-1024x512.webp" alt="Dukes Roadhouse" className="h-10 md:h-14 w-auto object-contain flex-shrink-0" data-id="element-41" />
              <img src="https://cdn.magicpatterns.com/uploads/qWCvgT6G6q3v6EDH7A5sis/extra-space-storage-color.svg" alt="Extra Space Storage" className="h-10 md:h-14 w-auto object-contain flex-shrink-0" data-id="element-42" />
              <img src="https://cdn.magicpatterns.com/uploads/1rQ3evs2dMV2tMvjtnMk46/kindercare-logo-color.svg" alt="KinderCare" className="h-10 md:h-14 w-auto object-contain flex-shrink-0" data-id="element-43" />
              <img src="https://cdn.magicpatterns.com/uploads/b6rkNof888pp24tqjfVpvH/Sonic_Drive-In-Logo.wine.png" alt="Sonic Drive-In" className="h-10 md:h-14 w-auto object-contain flex-shrink-0" data-id="element-44" />
              <img src="https://cdn.magicpatterns.com/uploads/wVXDyBv5jMbMo3s1hFtFcp/sprouts-logo-color-1024x512.webp" alt="Sprouts Farmers Market" className="h-10 md:h-14 w-auto object-contain flex-shrink-0" data-id="element-45" />
              <img src="https://cdn.magicpatterns.com/uploads/a4xD99moFi6X18HSsMQ4ua/thai-chili-2-go-logo-color.svg" alt="Thai Chili 2 Go" className="h-10 md:h-14 w-auto object-contain flex-shrink-0" data-id="element-46" />
              {/* Duplicate set for seamless loop */}
              <img src="https://cdn.magicpatterns.com/uploads/1ehYujopSpTK2NrZTqZpRk/birdcall-logo-color.svg" alt="Birdcall" className="h-10 md:h-14 w-auto object-contain flex-shrink-0" data-id="element-47" />
              <img src="https://cdn.magicpatterns.com/uploads/8YgbepPhZATz9aUogugo3L/bosa-donuts-logo-color.svg" alt="BoSa Donuts" className="h-10 md:h-14 w-auto object-contain flex-shrink-0" data-id="element-48" />
              <img src="https://cdn.magicpatterns.com/uploads/ffAJewCc2GvRFFDpoFKEVn/chopshop-logo-1024x512.webp" alt="Original ChopShop" className="h-10 md:h-14 w-auto object-contain flex-shrink-0" data-id="element-49" />
              <img src="https://cdn.magicpatterns.com/uploads/gNTQzPAt6hsyThojg6nfTt/darwin-wall-real-estate-team-logo-1024x512.webp" alt="Darwin Wall Real Estate Team" className="h-10 md:h-14 w-auto object-contain flex-shrink-0" data-id="element-50" />
              <img src="https://cdn.magicpatterns.com/uploads/pVcdgmgAGupmatevAoqQnh/dukes-roadhouse-logo-color-1024x512.webp" alt="Dukes Roadhouse" className="h-10 md:h-14 w-auto object-contain flex-shrink-0" data-id="element-51" />
              <img src="https://cdn.magicpatterns.com/uploads/qWCvgT6G6q3v6EDH7A5sis/extra-space-storage-color.svg" alt="Extra Space Storage" className="h-10 md:h-14 w-auto object-contain flex-shrink-0" data-id="element-52" />
              <img src="https://cdn.magicpatterns.com/uploads/1rQ3evs2dMV2tMvjtnMk46/kindercare-logo-color.svg" alt="KinderCare" className="h-10 md:h-14 w-auto object-contain flex-shrink-0" data-id="element-53" />
              <img src="https://cdn.magicpatterns.com/uploads/b6rkNof888pp24tqjfVpvH/Sonic_Drive-In-Logo.wine.png" alt="Sonic Drive-In" className="h-10 md:h-14 w-auto object-contain flex-shrink-0" data-id="element-54" />
              <img src="https://cdn.magicpatterns.com/uploads/wVXDyBv5jMbMo3s1hFtFcp/sprouts-logo-color-1024x512.webp" alt="Sprouts Farmers Market" className="h-10 md:h-14 w-auto object-contain flex-shrink-0" data-id="element-55" />
              <img src="https://cdn.magicpatterns.com/uploads/a4xD99moFi6X18HSsMQ4ua/thai-chili-2-go-logo-color.svg" alt="Thai Chili 2 Go" className="h-10 md:h-14 w-auto object-contain flex-shrink-0" data-id="element-56" />
            </div>
          </div>
        </section>

        {/* Benefits Strip */}
        <section className="bg-[#1B2A3D] text-white py-16 px-4" data-id="element-57">
          <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10 text-center" data-id="element-58">
            <div className="flex flex-col items-center" data-id="element-59">
              <ClockIcon className="w-12 h-12 text-[#0C8CE9] mb-4" data-id="element-60" />
              <h3 className="text-xl font-bold mb-3" data-id="element-61">After-Hours Service</h3>
              <p className="text-gray-300 leading-relaxed" data-id="element-62">
                We work nights and weekends so your business stays open. Zero
                disruption to your customers or employees.
              </p>
            </div>
            <div className="flex flex-col items-center" data-id="element-63">
              <ShieldCheckIcon className="w-12 h-12 text-[#0C8CE9] mb-4" data-id="element-64" />
              <h3 className="text-xl font-bold mb-3" data-id="element-65">
                Commercial-Grade Equipment
              </h3>
              <p className="text-gray-300 leading-relaxed" data-id="element-66">
                Industrial surface cleaners, hot water units & eco-friendly
                solutions for the toughest commercial jobs.
              </p>
            </div>
            <div className="flex flex-col items-center" data-id="element-67">
              <DollarSignIcon className="w-12 h-12 text-[#0C8CE9] mb-4" data-id="element-68" />
              <h3 className="text-xl font-bold mb-3" data-id="element-69">Flexible Contracts</h3>
              <p className="text-gray-300 leading-relaxed" data-id="element-70">
                One-time deep cleans or recurring maintenance plans. Custom
                scheduling to fit your property's needs.
              </p>
            </div>
          </div>
        </section>

        {/* See Our Work Section (Gallery) */}
        <section className="py-16 md:py-24 px-4 bg-white" data-id="element-71">
          <div className="max-w-6xl mx-auto" data-id="element-72">
            <h2 className="text-3xl md:text-4xl font-bold text-center text-[#1B2A3D] mb-4" data-id="element-73">
              Real Results for Phoenix Valley Businesses
            </h2>
            <p className="text-center text-[#1B2A3D] opacity-80 mb-12 max-w-2xl mx-auto" data-id="element-74">
              Parking lots, storefronts, gas stations, building exteriors — see
              what professional commercial power washing delivers.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-75">
              <img src="https://cdn.magicpatterns.com/uploads/fyF4Rsac6iP4SmaWdbiZbY/commercial_1.webp" alt="Commercial gas station parking lot power washing at night" loading="lazy" className="w-full h-64 md:h-80 rounded-xl shadow-lg object-cover" data-id="element-76" />
              <img src="https://cdn.magicpatterns.com/uploads/4RcEYR73kLK9iR4e625fig/commercial_2.webp" alt="Commercial concrete surface cleaning with steam during daytime" loading="lazy" className="w-full h-64 md:h-80 rounded-xl shadow-lg object-cover" data-id="element-77" />
              <img src="https://cdn.magicpatterns.com/uploads/bWUx8CPZy5TAP9pyZiVkec/commercial_3.webp" alt="Commercial storefront with clean wet parking lot at night" loading="lazy" className="w-full h-64 md:h-80 rounded-xl shadow-lg object-cover" data-id="element-78" />
              <img src="https://cdn.magicpatterns.com/uploads/jK81QueUW3apUohcRa9JW4/commercial_4.webp" alt="Blue Cactus team member with branded truck" loading="lazy" className="w-full h-64 md:h-80 rounded-xl shadow-lg object-cover" data-id="element-79" />
            </div>

            <div className="text-center mt-16" data-id="element-80">
              <button onClick={() => setIsModalOpen(true)} className="bg-transparent border-2 border-[#0C8CE9] text-[#0C8CE9] hover:bg-[#0C8CE9] hover:text-white font-bold text-xl py-4 px-10 rounded-full transition-colors shadow-sm" data-id="element-81">
                Get Your Property Looking Like This
              </button>
            </div>
          </div>
        </section>

        {/* Social Proof */}
        <section className="py-16 md:py-24 px-4 bg-[#E8F4FD]" data-id="element-82">
          <div className="max-w-6xl mx-auto" data-id="element-83">
            <div className="text-center mb-12" data-id="element-84">
              <div className="flex justify-center gap-1 mb-4" data-id="element-85">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-8 h-8 text-[#F5A623] fill-current" data-id="element-86" />)}
              </div>
              <h2 className="text-3xl font-bold text-[#1B2A3D]" data-id="element-87">
                Rated 5.0 on Google
              </h2>
              <p className="text-[#1B2A3D] opacity-80 mt-2" data-id="element-88">
                Based on 180+ reviews from property managers & business owners
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-89">
              {[{
              name: 'Mike R.',
              title: 'Property Manager, Phoenix',
              text: 'Blue Cactus handles all 12 of our retail locations. They work after hours, the lots look incredible every morning, and their pricing is very competitive for the quality.'
            }, {
              name: 'Amanda K.',
              title: 'Restaurant Owner, Scottsdale',
              text: 'Our patio and parking area were embarrassing before Blue Cactus. Now we get compliments from customers. They set up a monthly plan that keeps everything spotless.'
            }, {
              name: 'Carlos G.',
              title: 'Facility Director, Mesa',
              text: 'Professional, reliable, and thorough. They cleaned our entire warehouse exterior and loading dock area in one night. Highly recommend for any commercial property.'
            }].map((review, idx) => <div key={idx} className="bg-white p-8 rounded-xl shadow-sm relative flex flex-col" data-id="element-90">
                  <div className="flex text-[#F5A623] mb-4" data-id="element-91">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" data-id="element-92" />)}
                  </div>
                  <p className="text-[#1B2A3D] italic mb-6 flex-grow" data-id="element-93">
                    "{review.text}"
                  </p>
                  <div data-id="element-94">
                    <div className="font-bold text-[#1B2A3D]" data-id="element-95">
                      {review.name}
                    </div>
                    <div className="text-sm text-gray-500" data-id="element-96">{review.title}</div>
                  </div>
                </div>)}
            </div>

            <div className="text-center mt-12" data-id="element-97">
              <button onClick={() => setIsModalOpen(true)} className="bg-[#0C8CE9] hover:bg-[#0a7bc0] text-white font-bold text-xl py-4 px-10 rounded-full shadow-lg transform transition hover:scale-105" data-id="element-98">
                Join 100+ Satisfied Business Owners &rarr;
              </button>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-[#1B2A3D] text-white py-12 px-4 text-center" data-id="element-99">
        <div className="max-w-4xl mx-auto" data-id="element-100">
          <div className="flex flex-col items-center justify-center mb-6" data-id="element-101">
            <img src="https://cdn.magicpatterns.com/uploads/12oFyLJ3njFiy4SGXXx26A/BlueCactus_Power_Washing_Logo_White.svg" alt="Blue Cactus Power Washing" className="h-12 w-auto" data-id="element-102" />
          </div>
          <p className="text-xl font-bold mb-4" data-id="element-103">(480) 599-8442</p>
          <p className="text-gray-400 mb-8" data-id="element-104">Licensed • Bonded • Insured</p>
          <p className="text-sm text-gray-500" data-id="element-105">
            &copy; {new Date().getFullYear()} Blue Cactus Power Washing. All
            rights reserved.
          </p>
        </div>
      </footer>

      {/* Sticky Mobile CTA */}
      <div className="fixed bottom-0 left-0 right-0 bg-white p-4 shadow-[0_-10px_15px_-3px_rgba(0,0,0,0.1)] md:hidden flex justify-between items-center z-50 border-t border-gray-100" data-id="element-106">
        <a href="tel:4805998442" className="flex flex-col items-center justify-center w-1/2 border-r border-gray-200 text-[#1B2A3D]" data-id="element-107">
          <PhoneIcon className="w-5 h-5 text-[#0C8CE9] mb-1" data-id="element-108" />
          <span className="text-xs font-bold" data-id="element-109">Call Us</span>
        </a>
        <button onClick={() => setIsModalOpen(true)} className="w-1/2 text-center text-[#0C8CE9] font-bold text-sm" data-id="element-110">
          Get Quote
        </button>
      </div>

      {/* Modal Overlay */}
      {isModalOpen && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-[#1B2A3D]/80 backdrop-blur-sm overflow-y-auto" data-id="element-111">
          <div className="relative w-full max-w-xl my-8 mt-16" data-id="element-112">
            <button onClick={() => setIsModalOpen(false)} className="absolute -top-12 right-0 text-white hover:text-gray-300 transition-colors flex items-center gap-2" data-id="element-113">
              <span className="font-bold" data-id="element-114">Close</span>
              <X className="w-8 h-8" data-id="element-115" />
            </button>
            <LeadForm variant="commercial" data-id="element-116" />
          </div>
        </div>}
    </div>;
}